import { faPlus, faRefresh } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@mui/material';
import Grid from '@mui/material/Grid';

import CheckPermissions from '@/components/CheckPermissions';
import ExportButton from '@/components/ExportButton';
import PERMISSIONS from '@/constants/auth.constants';
import { PERMISSIONS_LOGIC } from '@/constants/common';

import type { DefaultActionsToolbarProps } from './DefaultActionsToolbar.types';

/**
 * Default toolbar with add source, export, and refresh actions.
 * Displayed when no sources are selected for bulk actions.
 *
 * @component
 * @example
 * ```tsx
 * <DefaultActionsToolbar
 *   onAdd={handleAddSource}
 *   onExport={handleExport}
 *   onRefresh={handleRefresh}
 *   collapsed={isCollapsed}
 *   exportData={cloudSources}
 * />
 * ```
 */
const DefaultActionsToolbar = ({
  onAdd,
  onExport,
  onRefresh,
  collapsed,
  exportData,
  addButtonClassName
}: DefaultActionsToolbarProps) => {
  return (
    <Grid
      sx={{
        maxHeight: '1.8rem'
      }}
      container
      spacing={2}
    >
      <CheckPermissions
        permissions={[PERMISSIONS.SOURCES_CREATE, PERMISSIONS.ADMIN_UPDATE]}
        logic={PERMISSIONS_LOGIC.OR}
      >
        <Button
          className={addButtonClassName}
          variant="contained"
          onClick={onAdd}
          startIcon={<FontAwesomeIcon icon={faPlus} />}
        >
          {collapsed && <span style={{ marginLeft: '.5rem' }}>Add Source</span>}
        </Button>
      </CheckPermissions>

      <ExportButton
        data={exportData}
        fileName="pondurance-cloud-sources"
        json
        csv
        handleExportCsv={onExport}
      />

      <Button variant="outlined" onClick={onRefresh}>
        <FontAwesomeIcon size="lg" icon={faRefresh} />
      </Button>
    </Grid>
  );
};

export default DefaultActionsToolbar;
